import { Card } from './ui/card';
import axios from 'axios';
import { API } from '../App';
import { toast } from 'sonner';
import { Bell, CheckCircle, X } from 'lucide-react';
import { Button } from './ui/button';

const Notifications = ({ notifications, onUpdate }) => {
  const handleMarkRead = async (notificationId) => {
    try {
      await axios.put(`${API}/notifications/${notificationId}/read`);
      onUpdate();
    } catch (error) {
      toast.error('Failed to mark notification as read');
    }
  };

  const handleMarkAllRead = async () => {
    try {
      const unreadNotifications = notifications.filter(n => !n.read);
      await Promise.all(
        unreadNotifications.map(notif => axios.put(`${API}/notifications/${notif.id}/read`))
      );
      toast.success('All notifications marked as read');
      onUpdate();
    } catch (error) {
      toast.error('Failed to mark all as read');
    }
  };

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className="space-y-4 animate-fade-in" data-testid="notifications-section">
      <Card className="p-6 bg-white shadow-lg border-0">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Notifications {unreadCount > 0 && <span className="text-sm text-gray-500">({unreadCount} unread)</span>}
          </h3>
          {unreadCount > 0 && (
            <Button
              onClick={handleMarkAllRead}
              variant="outline"
              size="sm"
              data-testid="mark-all-read-button"
            >
              Mark All Read
            </Button>
          )}
        </div>
        <div className="space-y-3">
          {notifications.length === 0 ? (
            <p className="text-gray-500 text-center py-8">No notifications</p>
          ) : (
            notifications.map(notif => (
              <Card
                key={notif.id}
                className={`p-4 border-2 ${notif.read ? 'bg-gray-50 border-gray-200' : 'bg-blue-50 border-blue-200'}`}
                data-testid={`notification-${notif.id}`}
              >
                <div className="flex items-start justify-between">
                  <div className="flex items-start space-x-3 flex-1">
                    <Bell className={`w-5 h-5 mt-0.5 ${notif.read ? 'text-gray-400' : 'text-blue-500'}`} />
                    <div className="flex-1">
                      <p className={`text-sm ${notif.read ? 'text-gray-600' : 'text-gray-900 font-medium'}`}>
                        {notif.message}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {new Date(notif.created_at).toLocaleString()}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-1 ml-2">
                    {!notif.read && (
                      <Button
                        size="sm"
                        variant="ghost"
                        onClick={() => handleMarkRead(notif.id)}
                        className="hover:bg-blue-100"
                        data-testid={`mark-read-${notif.id}`}
                        title="Mark as read"
                      >
                        <CheckCircle className="w-4 h-4" />
                      </Button>
                    )}
                    <Button
                      size="sm"
                      variant="ghost"
                      onClick={() => handleMarkRead(notif.id)}
                      className="hover:bg-red-100 text-gray-500 hover:text-red-600"
                      data-testid={`close-notification-${notif.id}`}
                      title="Dismiss"
                    >
                      <X className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
              </Card>
            ))
          )}
        </div>
      </Card>
    </div>
  );
};

export default Notifications;